import { render, staticRenderFns } from "./CeremonyHighlightCollectionsIndex.vue?vue&type=template&id=b3bd4d9c&scoped=true"
import script from "./CeremonyHighlightCollectionsIndex.vue?vue&type=script&lang=js"
export * from "./CeremonyHighlightCollectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./CeremonyHighlightCollectionsIndex.vue?vue&type=style&index=0&id=b3bd4d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd4d9c",
  null
  
)

export default component.exports